export { useLicenseVerifier } from "./useLicenseVerifier.js";